import { createReducer, on } from '@ngrx/store';
import {
  cancelPreviewsArchiveRequest,
  requestMockupsArchive,
  requestPreviewsArchive,
  setPreviewsArchiveTask,
  setPreviewsArchiveUrl,
  updatePreviewsArchiveTaskProgress,
} from './previews-archive.actions';

export interface Task {
  taskId: string;
  productTitle: string;
  total: number;
  done: number;
}

export interface State {
  isLoading: boolean;
  tasks: Task[];
  url: string;
}

export const initialState: State = {
  isLoading: false,
  tasks: [],
  url: null,
};

export const reducer = createReducer(
  initialState,
  on(requestPreviewsArchive, requestMockupsArchive, state => ({
    ...state,
    isLoading: true,
  })),
  on(setPreviewsArchiveTask, (state, { payload: { taskId, productTitle, previewsAmount } }) => {
    if (state.tasks.find(t => t.taskId === taskId)) {
      return state;
    }

    return {
      ...state,
      tasks: [...state.tasks, { taskId, productTitle, total: previewsAmount, done: 0 }],
    };
  }),
  on(updatePreviewsArchiveTaskProgress, (state, { payload: { taskId, done, total } }) => {
    const taskIndex = state.tasks.findIndex(t => t.taskId === taskId);
    if (taskIndex === -1) {
      return state;
    }

    const tasks = [...state.tasks];
    tasks[taskIndex] = { ...tasks[taskIndex], done, total };

    return {
      ...state,
      tasks,
    };
  }),
  on(setPreviewsArchiveUrl, (state, { payload: { taskId, url } }) => {
    const tasks = state.tasks.filter(t => t.taskId !== taskId);

    return {
      ...state,
      isLoading: Boolean(tasks.length),
      tasks,
      url,
    };
  }),
  on(cancelPreviewsArchiveRequest, (state, { payload }) => {
    const tasks = state.tasks.filter(t => t.taskId !== payload);

    return {
      ...state,
      isLoading: Boolean(tasks.length),
      tasks,
    };
  }),
);
